/**
 * Lightweight analytics wrapper. Wraps PostHog when VITE_POSTHOG_KEY is set,
 * otherwise no-ops. Used for event tracking across web + native.
 */
type Props = Record<string, string | number | boolean | null>;

let inited = false;
let phRef: typeof import("posthog-js")["default"] | null = null;

export async function initAnalytics() {
  if (inited) return;
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  if (!key) return;
  try {
    const ph = (await import("posthog-js")).default;
    ph.init(key, {
      api_host: (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://app.posthog.com",
      capture_pageview: true,
      autocapture: false,
      persistence: "localStorage",
    });
    phRef = ph;
    inited = true;
  } catch {/* noop */}
}

export function track(event: string, props?: Props) {
  try { phRef?.capture(event, props as Record<string, unknown>); } catch {/* noop */}
}

export function identify(userId: string, traits?: Props) {
  try { phRef?.identify(userId, traits as Record<string, unknown>); } catch {/* noop */}
}

export function resetAnalytics() {
  try { phRef?.reset(); } catch {/* noop */}
}
